import COM from './ScrollModifier'

export default COM
